import {
  CatalogColumn,
  ColumnFilter,
  FilterState,
} from 'src/app/features/listing-product-table-v2/types'
import {
  hasActiveFilterValue,
  isDateRangeFilterValue,
  resolveColumnFilterInputType,
} from 'src/app/features/listing-product-table-lite/filterUtils'

const resolveFilterOperator = (
  filter: ColumnFilter,
  column?: CatalogColumn
): string | null => {
  if (isDateRangeFilterValue(filter.value)) {
    return null
  }

  if (filter.operator) {
    return filter.operator
  }

  const inputType = column ? resolveColumnFilterInputType(column) : 'TEXT'
  if (inputType === 'SELECT') {
    return 'equals'
  }

  return 'contains'
}

export const normalizePayoutFilterState = (
  filters: FilterState,
  catalogColumns: CatalogColumn[] = []
): FilterState => ({
  ...filters,
  columnFilters: (filters.columnFilters || []).map((filter) => {
    const column = catalogColumns.find((item) => item.field === filter.field)
    const operator = resolveFilterOperator(filter, column)
    return operator ? {...filter, operator} : filter
  }),
})

export const appendPayoutColumnFiltersToParams = (
  params: URLSearchParams,
  columnFilters: ColumnFilter[],
  catalogColumns: CatalogColumn[] = []
) => {
  columnFilters.forEach((filter) => {
    if (!hasActiveFilterValue(filter.value)) return

    const field = filter.field
    if (!field) return

    const column = catalogColumns.find((item) => item.field === field)

    if (isDateRangeFilterValue(filter.value)) {
      if (filter.value.from) {
        params.append(`${field}_from`, filter.value.from)
      }
      if (filter.value.to) {
        params.append(`${field}_to`, filter.value.to)
      }
      return
    }

    params.append(field, String(filter.value))

    const operator = resolveFilterOperator(filter, column)
    if (operator) {
      params.append(`${field}_operator`, operator)
    }
  })
}
